import React from 'react';
import { SearchIcon } from './Icons';

export const SearchBox = ({ value, onChange, placeholder = 'Search...' }) => (
  <div className="flex items-center gap-2 px-3 py-2 bg-slate-50 border border-slate-200/50 rounded-lg w-72
    transition-all focus-within:border-purple-500 focus-within:ring-3 focus-within:ring-purple-200">
    <SearchIcon size={16} className="text-slate-400 flex-shrink-0" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="border-none bg-transparent outline-none text-sm w-full font-sans text-slate-800 placeholder:text-slate-400"
    />
  </div>
);
